import { useEffect, useRef } from "react";

/**
 * Adds .is-visible to the element when it scrolls into view.
 * Usage: const ref = useReveal(); <div ref={ref} className="reveal">…</div>
 */
export default function useReveal(options = {}) {
  const ref = useRef(null);
  const optionsRef = useRef(options);
  optionsRef.current = options;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            el.classList.add("is-visible");
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -10% 0px", ...optionsRef.current }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}
